import { useCallback } from 'react';

import OtcPlpVerticalCard from './verticalPlpCards/otcPlpVerticalCard';
import NonOtcPlpVerticalCard from './verticalPlpCards/nonOtcPlpVerticalCard';
import ShopPlpVerticalCard from './verticalPlpCards/ShopPlpVerticalCard';
import { PlpVerticalCardProps, Product } from './plpCard.types';
import { ShopProductsItemModel } from '@models/shop';

const PlpVerticalCard = ({
  type,
  product,
  onClick,
  href,
  hasAddToCart = true,
  className,
  imagePriority = false,
}: PlpVerticalCardProps) => {
  const onClickHandler = useCallback(
    (e) => {
      e.stopPropagation();
      if (onClick) {
        onClick();
        return;
      }
    },
    [onClick],
  );

  if (type === 'otc') {
    return (
      <OtcPlpVerticalCard
        onClickHandler={onClickHandler}
        href={href}
        product={product as Product}
        hasAddToCart={hasAddToCart}
        className={className}
        imagePriority={imagePriority}
      />
    );
  }

  if (type === 'nonOtc') {
    return (
      <NonOtcPlpVerticalCard
        onClickHandler={onClickHandler}
        href={href}
        product={product as Product}
        hasAddToCart={hasAddToCart}
        className={className}
        imagePriority={imagePriority}
      />
    );
  }

  if (type === 'shop') {
    return (
      <ShopPlpVerticalCard
        onClickHandler={onClickHandler}
        product={product as ShopProductsItemModel}
        hasAddToCart={hasAddToCart}
        className={className}
        imagePriority={imagePriority}
      />
    );
  }

  return null;
};

export default PlpVerticalCard;
